const configPreset = 'spec'
const ConfigImport = require('@/configs/' + configPreset)
export const Config = ConfigImport.ConfigImport
